import React, { useState, useEffect } from 'react';
import { T, font, mono } from '../utils/theme';
import * as api from '../utils/api';
import { Card, Btn, Inp, Modal } from './UI';
import { money } from '../utils/money';

function StatCard({ label, value, sub, color }) {
  return (
    <Card style={{ padding: '16px 20px', textAlign: 'center' }}>
      <div style={{ fontSize: 11, color: T.dim, fontWeight: 700, textTransform: 'uppercase', marginBottom: 6 }}>{label}</div>
      <div style={{ fontSize: 26, fontWeight: 900, color: color || T.text, fontFamily: mono }}>{value}</div>
      {sub && <div style={{ fontSize: 11, color: T.muted, marginTop: 4 }}>{sub}</div>}
    </Card>
  );
}

function PeriodSection({ title, data, lang }) {
  if (!data) return null;
  return (
    <Card style={{ marginBottom: 16 }}>
      <div style={{ fontSize: 16, fontWeight: 800, color: T.text, marginBottom: 12 }}>{title}</div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 10, marginBottom: 16 }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: 10, color: T.dim, fontWeight: 700, textTransform: 'uppercase' }}>{lang === 'zh' ? '预估收入' : 'Est. Revenue'}</div>
          <div style={{ fontSize: 20, fontWeight: 800, color: T.accent, fontFamily: mono }}>${data.total_revenue.toLocaleString()}</div>
        </div>
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: 10, color: T.dim, fontWeight: 700, textTransform: 'uppercase' }}>{lang === 'zh' ? '商品成本' : 'Cost of Goods'}</div>
          <div style={{ fontSize: 20, fontWeight: 800, color: T.muted, fontFamily: mono }}>${data.total_cost.toLocaleString()}</div>
        </div>
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: 10, color: T.dim, fontWeight: 700, textTransform: 'uppercase' }}>{lang === 'zh' ? '运费成本' : 'Shipping Cost'}</div>
          <div style={{ fontSize: 20, fontWeight: 800, color: T.muted, fontFamily: mono }}>${data.total_shipping.toLocaleString()}</div>
        </div>
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: 10, color: T.dim, fontWeight: 700, textTransform: 'uppercase' }}>{lang === 'zh' ? '预估利润' : 'Est. Profit'}</div>
          <div style={{ fontSize: 20, fontWeight: 800, color: data.total_profit >= 0 ? T.success : T.danger, fontFamily: mono }}>${data.total_profit.toLocaleString()}</div>
        </div>
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 0', borderTop: `1px solid ${T.border}`, fontSize: 12 }}>
        <span style={{ color: T.dim }}>{lang === 'zh' ? '订单数' : 'Orders'}: <span style={{ fontFamily: mono, color: T.muted }}>{data.order_count}</span></span>
        <span style={{ color: T.dim }}>{lang === 'zh' ? '总数量' : 'Total Qty'}: <span style={{ fontFamily: mono, color: T.muted }}>{data.total_qty}</span></span>
        <span style={{ color: T.dim }}>{lang === 'zh' ? '利润率' : 'Profit Margin'}: <span style={{ fontFamily: mono, fontWeight: 700, color: data.profit_margin >= 20 ? T.success : data.profit_margin >= 10 ? T.warn : T.danger }}>{data.profit_margin}%</span></span>
      </div>

      {/* Top products */}
      {data.top_products && data.top_products.length > 0 && (
        <div style={{ marginTop: 12 }}>
          <div style={{ fontSize: 11, fontWeight: 800, color: T.dim, textTransform: 'uppercase', marginBottom: 8 }}>{lang === 'zh' ? '热门产品' : 'Top Products'}</div>
          <table style={{ width: '100%', fontSize: 11, fontFamily: font, borderCollapse: 'collapse' }}>
            <thead><tr>
              {[lang === 'zh' ? '产品' : 'Product', lang === 'zh' ? '数量' : 'Qty', lang === 'zh' ? '成本' : 'Cost', lang === 'zh' ? '运费' : 'Shipping', lang === 'zh' ? '预估收入' : 'Est. Revenue', lang === 'zh' ? '预估利润' : 'Est. Profit'].map((h, i) => (
                <th key={i} style={{ textAlign: 'left', padding: '4px 8px', background: T.surfaceAlt, color: T.dim, fontSize: 9, fontWeight: 800, textTransform: 'uppercase', borderBottom: `1px solid ${T.border}` }}>{h}</th>
              ))}
            </tr></thead>
            <tbody>
              {data.top_products.map((p, i) => {
                const profit = p.revenue - p.cost - p.shipping;
                return (
                  <tr key={i}>
                    <td style={{ padding: '4px 8px', borderBottom: `1px solid ${T.border}`, color: T.text, fontWeight: 600 }}>{p.name}</td>
                    <td style={{ padding: '4px 8px', borderBottom: `1px solid ${T.border}`, fontFamily: mono, color: T.muted }}>{p.qty}</td>
                    <td style={{ padding: '4px 8px', borderBottom: `1px solid ${T.border}`, fontFamily: mono, color: T.muted }}>{money(p.cost)}</td>
                    <td style={{ padding: '4px 8px', borderBottom: `1px solid ${T.border}`, fontFamily: mono, color: T.muted }}>{money(p.shipping)}</td>
                    <td style={{ padding: '4px 8px', borderBottom: `1px solid ${T.border}`, fontFamily: mono, color: T.accent }}>{money(p.revenue)}</td>
                    <td style={{ padding: '4px 8px', borderBottom: `1px solid ${T.border}`, fontFamily: mono, color: profit >= 0 ? T.success : T.danger }}>{money(profit)}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </Card>
  );
}

export default function AdminReports({ lang, Lk }) {
  const [authed, setAuthed] = useState(false);
  const [password, setPassword] = useState('');
  const [loginErr, setLoginErr] = useState('');
  const [reportData, setReportData] = useState(null);
  const [showChangePw, setShowChangePw] = useState(false);
  const [oldPw, setOldPw] = useState('');
  const [newPw, setNewPw] = useState('');
  const [changePwMsg, setChangePwMsg] = useState('');

  const doLogin = async () => {
    setLoginErr('');
    try {
      const result = await api.reportsAuth(password);
      if (result.success) {
        setAuthed(true);
        setPassword('');
        // Load report data
        const data = await api.getReportsData();
        setReportData(data);
      } else {
        setLoginErr(lang === 'zh' ? '密码错误' : 'Invalid password');
      }
    } catch (e) {
      setLoginErr(e.message);
    }
  };

  const doChangePw = async () => {
    setChangePwMsg('');
    try {
      const result = await api.reportsChangePassword(oldPw, newPw);
      if (result.success) {
        setChangePwMsg(lang === 'zh' ? '密码已更改!' : 'Password changed!');
        setOldPw(''); setNewPw('');
        setTimeout(() => { setShowChangePw(false); setChangePwMsg(''); }, 1500);
      } else {
        setChangePwMsg(result.error || (lang === 'zh' ? '更改失败' : 'Change failed'));
      }
    } catch (e) {
      setChangePwMsg(e.message);
    }
  };

  const refreshData = async () => {
    const data = await api.getReportsData();
    setReportData(data);
  };

  // Login screen
  if (!authed) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: 400 }}>
        <Card style={{ padding: '40px 50px', maxWidth: 400, width: '100%', textAlign: 'center' }}>
          <div style={{ width: 56, height: 56, borderRadius: 28, background: T.accent + '15', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px', border: `1px solid ${T.accent}30` }}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={T.accent} strokeWidth="2"><rect x="3" y="11" width="18" height="11" rx="2" ry="2" /><path d="M7 11V7a5 5 0 0 1 10 0v4" /></svg>
          </div>
          <div style={{ fontSize: 20, fontWeight: 900, color: T.text, marginBottom: 6 }}>{lang === 'zh' ? '报表' : 'Reports'}</div>
          <div style={{ fontSize: 13, color: T.muted, marginBottom: 24 }}>{lang === 'zh' ? '请输入报表密码' : 'Enter reports password to continue'}</div>
          <Inp type="password" placeholder={lang === 'zh' ? '密码' : 'Password'} value={password}
            onChange={e => setPassword(e.target.value)}
            onKeyDown={e => { if (e.key === 'Enter') doLogin(); }}
            style={{ marginBottom: 12, textAlign: 'center' }} />
          {loginErr && <div style={{ color: T.danger, fontSize: 12, marginBottom: 10 }}>{loginErr}</div>}
          <Btn onClick={doLogin} style={{ width: '100%', justifyContent: 'center' }}>{lang === 'zh' ? '解锁报表' : 'Unlock Reports'}</Btn>
          <div style={{ fontSize: 11, color: T.dim, marginTop: 16 }}>{lang === 'zh' ? '默认密码: reports2026' : 'Default password: reports2026'}</div>
        </Card>
      </div>
    );
  }

  const p = reportData?.periods || {};

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 22 }}>
        <h2 style={{ margin: 0, fontSize: 22, fontWeight: 900, color: T.text }}>
          {lang === 'zh' ? '报表 & 分析' : 'Reports & Analytics'}
          <span style={{ fontSize: 11, color: T.dim, fontWeight: 600, marginLeft: 8 }}>{lang === 'zh' ? '(预估数据)' : '(Estimated)'}</span>
        </h2>
        <div style={{ display: 'flex', gap: 8 }}>
          <Btn variant="ghostSm" onClick={refreshData}>↻ {lang === 'zh' ? '刷新' : 'Refresh'}</Btn>
          <Btn variant="ghostSm" onClick={() => setShowChangePw(true)}>🔑 {lang === 'zh' ? '改密码' : 'Change Password'}</Btn>
          <Btn variant="ghostSm" onClick={() => setAuthed(false)}>🔒 {lang === 'zh' ? '锁定' : 'Lock'}</Btn>
        </div>
      </div>

      {/* Disclaimer */}
      <div style={{ background: T.warnBg, border: `1px solid ${T.warn}30`, borderRadius: 8, padding: '10px 16px', marginBottom: 20, fontSize: 12, color: T.warn }}>
        ⚠ {lang === 'zh' ? '以下数据均为基于历史补货记录的预估值，不构成实际财务报告。未设置售价的产品使用1.5倍成本估算收入。' : 'All figures below are estimates based on historical reorder data. Products without a selling price use 1.5x cost markup. This is not an actual financial report.'}
      </div>

      {/* Dashboard summary cards */}
      {p.last_month && (
        <div style={{ marginBottom: 20 }}>
          <div style={{ fontSize: 12, fontWeight: 800, color: T.dim, textTransform: 'uppercase', marginBottom: 8 }}>{lang === 'zh' ? '上月概览' : 'Last Month Overview'}</div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 10 }}>
            <StatCard label={lang === 'zh' ? '预估收入' : 'Est. Revenue'} value={`$${p.last_month.total_revenue.toLocaleString()}`} color={T.accent} />
            <StatCard label={lang === 'zh' ? '预估利润' : 'Est. Profit'} value={`$${p.last_month.total_profit.toLocaleString()}`} color={p.last_month.total_profit >= 0 ? T.success : T.danger} />
            <StatCard label={lang === 'zh' ? '利润率' : 'Profit Margin'} value={`${p.last_month.profit_margin}%`} color={p.last_month.profit_margin >= 20 ? T.success : p.last_month.profit_margin >= 10 ? T.warn : T.danger} />
            <StatCard label={lang === 'zh' ? '订单数' : 'Orders'} value={p.last_month.order_count} sub={`${p.last_month.total_qty} ${lang === 'zh' ? '件' : 'units'}`} />
          </div>
        </div>
      )}

      {/* Period breakdowns */}
      <PeriodSection title={lang === 'zh' ? '上月报表' : 'Last Month'} data={p.last_month} lang={lang} />
      <PeriodSection title={lang === 'zh' ? '近3个月报表' : 'Last 3 Months'} data={p.last_3_months} lang={lang} />
      <PeriodSection title={lang === 'zh' ? '近一年报表' : 'Last Year'} data={p.last_year} lang={lang} />

      {/* Shipping cost info */}
      {reportData?.global_avg_ship_cost > 0 && (
        <div style={{ fontSize: 11, color: T.dim, textAlign: 'center', padding: 10 }}>
          {lang === 'zh' ? '平均每件运费' : 'Avg shipping cost per unit'}: <span style={{ fontFamily: mono, color: T.muted }}>{money(reportData.global_avg_ship_cost)}</span>
        </div>
      )}

      {/* No data message */}
      {!p.last_month && !p.last_3_months && !p.last_year && (
        <div style={{ color: T.dim, fontSize: 13, fontStyle: 'italic', padding: 40, textAlign: 'center' }}>
          {lang === 'zh' ? '暂无数据。开始补货后，报表将自动生成。' : 'No data yet. Reports will populate as you complete reorder cycles.'}
        </div>
      )}

      {/* Change Password Modal */}
      <Modal open={showChangePw} onClose={() => { setShowChangePw(false); setChangePwMsg(''); }}>
        <div style={{ fontSize: 18, fontWeight: 800, color: T.text, marginBottom: 16 }}>{lang === 'zh' ? '更改报表密码' : 'Change Reports Password'}</div>
        <Inp type="password" label={lang === 'zh' ? '当前密码' : 'Current Password'} value={oldPw} onChange={e => setOldPw(e.target.value)} style={{ marginBottom: 10 }} />
        <Inp type="password" label={lang === 'zh' ? '新密码' : 'New Password'} value={newPw} onChange={e => setNewPw(e.target.value)}
          onKeyDown={e => { if (e.key === 'Enter') doChangePw(); }} style={{ marginBottom: 12 }} />
        {changePwMsg && <div style={{ fontSize: 12, color: changePwMsg.includes('changed') || changePwMsg.includes('已更改') ? T.success : T.danger, marginBottom: 10 }}>{changePwMsg}</div>}
        <div style={{ display: 'flex', gap: 10 }}>
          <Btn variant="secondary" onClick={() => { setShowChangePw(false); setChangePwMsg(''); }} style={{ flex: 1 }}>{Lk('cancel')}</Btn>
          <Btn onClick={doChangePw} style={{ flex: 1 }}>{lang === 'zh' ? '确认更改' : 'Confirm'}</Btn>
        </div>
      </Modal>
    </div>
  );
}
